/** Mirrors shopsmt_category_slug_from_name() in PHP. */
export function slugFromName(label) {
  const s = String(label ?? '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return s !== '' ? s : 'shop';
}

export function subcategorySlug(subcategory) {
  if (subcategory?.slug) {
    return String(subcategory.slug).toLowerCase();
  }
  return slugFromName(subcategory?.name);
}

export function findSubcategoryBySlug(category, rawSubSlug) {
  const subSlug = (rawSubSlug ?? '').toLowerCase();
  if (!subSlug || !category) {
    return null;
  }
  const subs = Array.isArray(category.subcategories) ? category.subcategories : [];
  return subs.find((sub) => subcategorySlug(sub) === subSlug) ?? null;
}
